"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankCard = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const document_1 = require("../../../../../reducers/slices/document/document");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const BlankCard = () => {
    const [mouseIsOver, setMouseIsOver] = (0, react_1.useState)(false);
    const { selectedDocument, templates, isLoading, selectedTemplateID } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const templateDiv = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (templateDiv) {
            const width = templateDiv.current.offsetWidth;
            templateDiv.current.style.height = `${width + width / 4}px`;
        }
    }, []);
    const handleSelectedTemplate = () => {
        let _class = "";
        if (selectedTemplateID === "blank") {
            _class = "border-secondary -translate-y-1 scale-110";
        }
        return _class;
    };
    return (react_1.default.createElement("div", { ref: templateDiv, onClick: () => {
            dispatch((0, document_1.setSelectedTemplateID)("blank"));
            // if (!selectedDocument?._id) {
            //   documentDetails();
            //   return;
            // }
            // window.open(`#${CONSOLE_ROUTE}${DOCUMENT_ROUTE}/${selectedDocument?._id}`, "_blank");
        }, className: `transition ease-in-out delay-150 w-full bg-white shadow-md border ${handleSelectedTemplate()} flex flex-col item-center cursor-pointer hover:border-primary hover:-translate-y-1 hover:scale-110 duration-300 relative` },
        selectedTemplateID === "blank" && (react_1.default.createElement("div", { className: " absolute top-1 left-[85%] flex justify-center items-center h-6 w-6 bg-secondary rounded-full" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheck, className: "text-white font-bold" }))),
        react_1.default.createElement("p", { className: "text-3xl font-bold text-muted-foreground flex flex-grow items-center justify-center" }, "Blank")));
};
exports.BlankCard = BlankCard;
